/*jshint esversion: 6 */
(function () {
    var markers = [];
    var markerCluster;
    var bounds;
    var map;
    var element;
    var icon;
    var selected_icon;
    var infowindow;
    var init = function () {
        initializeSideNavs();
        initializeSideNavEvents();
        initializeWeightSetting();
    };

    var initializeSideNavs = function () {
        var buttonSettings = {
            menuWidth: 500,
            edge: 'left',
            closeOnClick: false,
            onClose: function (val) {
                CompsController.resetForm();
            }
        };

        $('.button-collapse').sideNav(buttonSettings);
    };

    var initializeSideNavEvents = function () {
        if (document.getElementById("save-comp")) {
            document.getElementById("save-comp").addEventListener("click", function () {
                $(this).attr('disabled',false);
                saveComp();
            });
        }
    };

    function save(data, isEval, el=null) {
        startLoading('body');
        var url = 'comps/save';
        if(location.search.indexOf('res_evaluations/') !== -1) {
            url = "res_comps/save";
        }
        $.ajax({
            type: "POST",
            url: $("body").data("base-url") + url,
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            beforeSend: function (xhr) {
                showLoading();
            },
            success: function (responseText) {
                var res = JSON.parse(responseText);
                if(res.status=="fail"){
                    Materialize.toast(res.message,3000);
                    return false;
                }else if (res.id) {
                    window.location.href = $("body").data("base-url") + (data.get('redirect')).substr(1)+'?compId='+res.id;
                }
            },
            failure: function (errMsg) {
                Materialize.toast("It was not possible to execute that action.", 2000);
                $('#save-comp').attr('disabled',false);
                stopLoading('body');
            }
        }).done(function () {
            hideLoading();
            if (el && el.length) {
                var elP = el.parent().parent().parent();
                if (elP.hasClass('comp-current')) {
                    stopLoading('.comp-current');
                } else{
                    stopLoading('.comp-entry');
                }
            }
        })
    }

    var saveComp = function () {
        if(location.search.indexOf('res_evaluations/') !== -1) {
            Utils.setIndexes('zonings', 9);
        }else{
            Utils.setIndexes('zonings', 7);
            Utils.setIndexes('property_unit', 6);
            if ($("select[name='type']").val() === 'sale') {
                $("select[name='lease_type']").val('');
                $("[name=lease_rate]").val('');
                $("[name=term]").val('');
            } else if ($("select[name='type']").val() === 'lease') {
                $("[name=sale_price]").val('');
                $("[name=net_operating_income]").val('');
                $("[name=cap_rate]").val('');
            }
        }
        var form = $("#comps-form");

        if (form.valid()) {
            unmaskFields();
            $('.space').each(function() { 
                $(this).val($(this).val().replace(/\$|\s|[, ]/g, ''));
            });

            var data = new FormData(form[0]);

            var id = form.find("[name=id]").val();
            var isEval = form.find("[name=addToEvaluation]").val();
            var el = null;
            if(id) {
                el = $('.view-comp-from-approach[data-id=' + id + ']');

                if(el.length) {
                    var elP = el.parent().parent().parent();
                    if(elP.hasClass('comp-current')) {
                        startLoading('.comp-current');
                    } else if(elP.hasClass('comp-entry')){
                        startLoading('.comp-entry');
                    }
                }
            }

            data.append('property_type', $('select.property_type').val());

            if (form.find('#image').data('cropper') !== undefined) {
                form.find('#image').cropper('getCroppedCanvas').toBlob(function (blob) {
                    data.append('property_image_url', blob, 'property_image_url');
                    if(el==null)
                    {
                        save(data, isEval);
                    }else{
                        save(data, isEval, el);
                    }
                },"image/jpeg",0.75);
            } else {
                if(el==null)
                {
                    save(data, isEval);
                }else{
                    save(data, isEval, el);
                }
            }
        } else {
            $('#save-comp').attr('disabled',false);
            if(location.search.indexOf('res_evaluations/') !== -1) {
                Utils.unsetIndexes('zonings', 9);
            }else{
                Utils.unsetIndexes('zonings', 7);
                Utils.unsetIndexes('property_unit', 6);
            }
            Materialize.toast('Please complete the missing fields.', 3000, 'blue');
        }
    };

    var showLoading = function() {
        $('body').LoadingOverlay("show",
            {
                image: $('body').attr('data-base-url') + "assets/img/loading.png",
                imageAnimation: '2500ms rotate_left',
                zIndex: 1005,
                background: "rgba(255, 255, 255, 0.95)"
            }
        );
    };

    var hideLoading = function() {
        $('body').LoadingOverlay("hide");
    };

    function openWeightModal() {
        var modal = $('#modalWeight');
        if ($(this).data('field') === 'income_weight') {
            modal.find('input[name=id]').val($('input[name="evaluation_income_approaches[id]"]').val());
        }

        if ($(this).data('field') === 'sales_weight') {
            modal.find('input[name=id]').val($('input[name="evaluation_sales_approaches[id]"]').val());
        }

        if ($(this).data('field') === 'cost_weight') {
            modal.find('input[name=id]').val($('input[name="evaluation_cost_approaches[id]"]').val());
        }

        modal.find('input[name=approach]').val($(this).data('field'));
        modal.find('input#weight').val($(this).attr('data-value'));
        modal.find('label').text($(this).data('field-label'));
        $('.submit-new-weight').attr('disabled',false);
        modal.modal('open');
    }
    var saveEvalTotalWeight = function () {
        var evalForm = $("#evaluation-form");
        $.ajax({
            type: "POST",
            url: $("body").data("base-url") + "evaluations/save",
            data: {
                'evaluation[id]': $("[name='evaluation[id]']").val(),
                'evaluation[weighted_market_value]': evalForm.find('#weighted-value-input').val()
            }
        });
    };

    function saveWeight() {
        var evalForm = $("#evaluation-form");
        var form = $("#weight-form");
        var incremental;
        if(form.find('[name=approach]').val()=="income_weight")
        {
            incremental = $('#income-approach-total-lg').text().replace(/[^\d.-]/g, '')*toNumberFromPercent(form.find('#weight'));
        }else if(form.find('[name=approach]').val()=="sales_weight")
        {
            incremental = $('#sales-approach-total-lg').text().replace(/[^\d.-]/g, '')*toNumberFromPercent(form.find('#weight'));
        }else if(form.find('[name=approach]').val()=="cost_weight")
        {
            incremental = $('#cost-approach-total-lg').text().replace(/[^\d.-]/g, '')*toNumberFromPercent(form.find('#weight'));
        }
        $.ajax({
            type: "POST",
            url: $("body").data("base-url") + "approaches/save/" + form.find('input[name=id]').val(),
            data: {
                'eval_weight': toNumberFromPercent(form.find('#weight')),
                'evaluation_id': $("[name='evaluation[id]']").val(),
                'approach': form.find('[name=approach]').val(),
                'weighted_market_value': evalForm.find('#weighted-value-input').val(),
                'incremental':incremental
            },
            success: function (responseText) {
                var response = JSON.parse(responseText);

                if (response !== 'failure') {
                    if (response.income_weight) {
                        response.income_weight = (response.income_weight*100).toFixed(2).toString();
                        if(response.income_weight.indexOf(".00") != -1)
                        {
                            response.income_weight = parseInt(response.income_weight);
                        }
                        $('#income-approach-weight').text(response.income_weight);
                        $('#income-approach-percentage').attr('data-value', response.income_weight);
                    }

                    if (response.sales_weight) {
                        response.sales_weight = (response.sales_weight*100).toFixed(2).toString();
                        if(response.sales_weight.indexOf(".00") != -1)
                        {
                            response.sales_weight = parseInt(response.sales_weight);
                        }
                        $('#sales-approach-weight').text(response.sales_weight);
                        $('#sales-approach-percentage').attr('data-value', response.sales_weight);
                    }

                    if (response.cost_weight) {
                        response.cost_weight = (response.cost_weight*100).toFixed(2).toString();
                        if(response.cost_weight.indexOf(".00") != -1)
                        {
                            response.cost_weight = parseInt(response.cost_weight);
                        }
                        $('#cost-approach-weight').text(response.cost_weight);
                        $('#cost-approach-percentage').attr('data-value', response.cost_weight);
                    }
                }
            },
            failure: function (errMsg) {
                Materialize.toast("It was not possible to execute that action.", 2000);
            }
        }).done(function () {
            ApproachCalculator.updateSidebar(1);
        });
    }

    var initializeWeightSetting = function () {
        $('#modalWeight').modal({
                dismissible: true, // Modal can be dismissed by clicking outside of the modal
                inDuration: 300, // Transition in duration
                outDuration: 200, // Transition out duration
                startingTop: '4%', // Starting top style attribute
                endingTop: '10%'
            }
        );
        
        $("#income-approach-percentage, #sales-approach-percentage, #cost-approach-percentage").on('click', function () {
            openWeightModal.call(this);
        });

        $(document).on('click', '.submit-new-weight', function () {
            // currently not used for residential evals
            if (location.pathname.indexOf('/res_evaluations') !== -1)
                saveResWeight();
            else
                saveWeight();
        });
    };

    // for residential evals but currently not in use
    function saveResWeight() {
        var evalForm = $("#evaluation-form");
        var form = $("#weight-form");
        var incremental;
        if(form.find('[name=approach]').val()=="income_weight")
        {
            incremental = $('#income-approach-total-lg').text().replace(/[^\d.-]/g, '')*toNumberFromPercent(form.find('#weight'));
        }
        else if(form.find('[name=approach]').val()=="sales_weight")
        {
            incremental = $('#sales-approach-total-lg').text().replace(/[^\d.-]/g, '')*toNumberFromPercent(form.find('#weight'));
        }else if(form.find('[name=approach]').val()=="cost_weight")
        {
            incremental = $('#cost-approach-total-lg').text().replace(/[^\d.-]/g, '')*toNumberFromPercent(form.find('#weight'));
        }
        $.ajax({
            type: "POST",
            url: $("body").data("base-url") + "approaches/res_save/" + form.find('input[name=id]').val(),
            data: {
                'eval_weight': toNumberFromPercent(form.find('#weight')),
                'res_evaluation_id': $("[name='evaluation[id]']").val(),
                'approach': form.find('[name=approach]').val(),
                'weighted_market_value': evalForm.find('#weighted-value-input').val(),
                'incremental':incremental
            },
            success: function (responseText) {
                var response = JSON.parse(responseText);

                if (response !== 'failure') {

                    if (response.income_weight) {
                        response.income_weight = (response.income_weight*100).toFixed(2).toString();
                        if(response.income_weight.indexOf(".00") != -1)
                        {
                            response.income_weight = parseInt(response.income_weight);
                        }
                        $('#income-approach-weight').text(response.income_weight);
                        $('#income-approach-percentage').attr('data-value', response.income_weight);
                    }

                    if (response.sales_weight) {
                        response.sales_weight = (response.sales_weight*100).toFixed(2).toString();
                        if(response.sales_weight.indexOf(".00") != -1)
                        {
                            response.sales_weight = parseInt(response.sales_weight);
                        }
                        $('#sales-approach-weight').text(response.sales_weight);
                        $('#sales-approach-percentage').attr('data-value', response.sales_weight);
                    }
                    if (response.cost_weight) {
                        response.cost_weight = (response.cost_weight*100).toFixed(2).toString();
                        if(response.cost_weight.indexOf(".00") != -1)
                        {
                            response.cost_weight = parseInt(response.cost_weight);
                        }
                        $('#cost-approach-weight').text(response.cost_weight);
                        $('#cost-approach-percentage').attr('data-value', response.cost_weight);
                    }
                }
            },
            failure: function (errMsg) {
                Materialize.toast("It was not possible to execute that action.", 2000);
            }
        }).done(function () {
            ApproachCalculator.updateSidebar(1);
        });
    }

    if (window.EvaluationsCommons === undefined) {
        window.EvaluationsCommons = {};
    }

    var initMap = function () {
        element = document.getElementById('listings-map');
        if (location.pathname.indexOf('/comps') !== -1 || location.pathname.indexOf('/res_comps') !== -1) {
            element = document.getElementById('advance-listings-map');
        }

        icon = element.getAttribute('data-icon');

        selected_icon = element.getAttribute('data-selected-icon');

        var styledMapType = new google.maps.StyledMapType(
            [
                {
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#444444"}]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [{"color": "#f2f2f2"}]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [{"visibility": "off"}]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [{"saturation": -100}, {"lightness": 45}]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [{"visibility": "simplified"}]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [{"visibility": "off"}]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [{"visibility": "off"}]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [{"color": "#46bcec"}, {"visibility": "on"}]
                }
            ],
            {name: 'Map'});

        map = new google.maps.Map(element, {
            zoom: 14,
            gestureHandling: 'greedy',
            mapTypeControlOptions: {
                mapTypeIds: ['styled_map', 'hybrid']
            }
        });

        map.mapTypes.set('styled_map', styledMapType);
        map.setMapTypeId('styled_map');

        infowindow = new google.maps.InfoWindow();

        bounds = new google.maps.LatLngBounds();

        //Change label from Hybrid to Satellite
        google.maps.event.addListenerOnce(map,'idle',function () {
            map.mapTypes.hybrid.name='Satellite';
            map.setOptions({'mapTypeControl': true});
        });
        map.setCenter(Utils.getUSACenter());
    };

    function resetMarkers() {
        for (var i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }

        markers = [];

        if(markerCluster) {
            markerCluster.clearMarkers();
        }
    }

    var getMap = function () {
        return map;
    };

    var checkMap = function () {
        // Group markers
        try{
            markerCluster = new MarkerClusterer(map, markers,
            {
                imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
                minimumClusterSize: 3,
                maxZoom: 14
            });
            if (markers.length === 0) {
                setDefault();
            }
        }catch(e){
            setDefault();
        }
    };

    function buildListing(propertyInstance) {
        //Create a marker with the property template
        var marker = new google.maps.Marker
        (
            {
                position:
                    new google.maps.LatLng
                    (
                        propertyInstance.latitude,
                        propertyInstance.longitude
                    ),
                map: map,
                icon: icon,
                propertyInstance: propertyInstance
            }
        );
        //Capture click event and open marker's info window
        let option_val = 0;
        let current_option_val = {};
        marker.addListener('click', function () {
            if(location.pathname.indexOf('/multiFamilyComps') !== -1){
                $('.if_multi').removeClass('hide');
            }
            if(location.pathname.indexOf('/leaseComps') !== -1){
                $('.if_lease').removeClass('hide');
            }else{
                $('.if_sale').removeClass('hide');
            }
            infowindow.close(); 
            infowindow = new google.maps.InfoWindow();
            var mapInfoWindow = $('#map-info-windows');
            var id = '';
            if (location.pathname.indexOf('/comps') !== -1 || location.pathname.indexOf('/res_comps') !== -1) {
                id = this.get('propertyInstance').DT_RowId;
                if($(".select_lease_sale:checked").val()=='lease_comps'){
                    $('.if_lease').removeClass('hide');
                    $('.if_sale').addClass('hide');
                    mapInfoWindow.find('.comp_price_sf').html('$/SF/YR: '+this.get('propertyInstance').price_square_foot);
                }else{
                    $('.if_sale').removeClass('hide');
                    $('.if_lease').addClass('hide');
                    mapInfoWindow.find('.comp_price_sf').html('$/SF: '+this.get('propertyInstance').price_square_foot);
                }
                mapInfoWindow.find('.comp_address').html(this.get('propertyInstance').street_address);
                mapInfoWindow.find('.comp_sale_price').html('Sale Price: '+this.get('propertyInstance').sale_price);
                mapInfoWindow.find('.comp_building_size').html('Building Size: '+this.get('propertyInstance').building_size);
                mapInfoWindow.find('.comp_land_size').html('Land Size: '+this.get('propertyInstance').land_size);
                mapInfoWindow.find('.comp_land_type').html('Type: '+this.get('propertyInstance').zone);
                mapInfoWindow.find('.comp_date_sold').html('Date Sold: '+this.get('propertyInstance').date_sold);
                mapInfoWindow.find('.comp_suite_num').html('Suite Number: '+this.get('propertyInstance').street_suite);
                mapInfoWindow.find('.comp_lease_type').html('Lease Type: '+this.get('propertyInstance').lease_type);
                mapInfoWindow.find('.comp_terms').html('Terms (Months): '+this.get('propertyInstance').term);
                mapInfoWindow.find('#iw-view-btn').attr('data-id',id);
                mapInfoWindow.find('#iw-view-btn').attr('href','#'+id);
                if (location.pathname.indexOf('/res_comps') !== -1) {
                    mapInfoWindow.find('#iw-edit-btn').attr('onclick','ResCompsController.openForm('+id+')');
                }else{
                    mapInfoWindow.find('#iw-edit-btn').attr('onclick','CompsController.openForm('+id+')');
                }
            }else{
                id = this.get('propertyInstance').c_id;
                mapInfoWindow.find('.comp_address').html(this.get('propertyInstance').street_address+','+this.get('propertyInstance').city);
                mapInfoWindow.find('.comp_sale_price').html('Sale Price: '+this.get('propertyInstance').sale_price);
                mapInfoWindow.find('.comp_price_sf').html('$/SF: '+this.get('propertyInstance').price_square_foot);
                mapInfoWindow.find('.comp_cap_rate').html('CAP Rate: '+this.get('propertyInstance').cap_rate);
                mapInfoWindow.find('.comp_building_size').html('Building Size: '+this.get('propertyInstance').building_size);
                mapInfoWindow.find('.comp_land_size').html('Land Size: '+this.get('propertyInstance').land_size);
                mapInfoWindow.find('.comp_date_sold').html('Date Sold: '+this.get('propertyInstance').date_sold);
                mapInfoWindow.find('.comp_image').attr('src',this.get('propertyInstance').property_image_url);
                mapInfoWindow.find('#iw-select-btn').attr('prop_id',id);
                mapInfoWindow.find('#iw-close-btn').attr('prop_id',id);
                mapInfoWindow.find('.comp_suite_num').html('Suite Number: '+this.get('propertyInstance').street_suite);
                mapInfoWindow.find('.comp_lease_rate').html('Lease Rate: '+this.get('propertyInstance').price_square_foot);
                mapInfoWindow.find('.comp_lease_type').html('Lease Type: '+this.get('propertyInstance').lease_type);
                mapInfoWindow.find('.comp_terms').html('Terms-Months: '+this.get('propertyInstance').term);
                mapInfoWindow.find('.comp_space_size').html('Space Size: '+this.get('propertyInstance').space);
                mapInfoWindow.find('.comp_land_size').html('Land Size: '+this.get('propertyInstance').land_size);
                mapInfoWindow.find('.comp_lease_date').html('Lease Date: '+this.get('propertyInstance').date_sold);
                if(location.pathname.indexOf('/multiFamilyComps') !== -1){
                    let drop_box = '<select class="comp_unit "><option value="0">--Select--</option>'; 
                    let units_val = this.get('propertyInstance').property_units;
                    for(var key in units_val ){
                        drop_box += '<option  value="'+units_val[key].id+'">'+units_val[key].beds+ ' bed'+' / '+units_val[key].baths+' bath'+'</option>';
                    }
                        drop_box += '</select>'
                        mapInfoWindow.find('.comp_property_units').html(drop_box);
                        if(current_option_val[id]){
                            $('.comp_unit option[value="'+current_option_val[id]+'"]').attr('selected','selected');
                        }
                }
            }
                
            var template = document.getElementById("map-info-windows").cloneNode(true);

            template.classList.remove("hide");
            infowindow.setContent(template);

            infowindow.addListener('domready', function () {
                var content = document.querySelector('.gm-style-iw');

                if (content.nextElementSibling) {
                    content.parentNode.removeChild(content.nextElementSibling);
                }
                content.style.setProperty('width', 'auto', 'important');
                content.style.setProperty('right', content.style.left, 'important');
                content.style.setProperty('text-align', 'center', 'important');
                if($('#iw-close-btn').length){
                    var closeBtn = $('#iw-close-btn').get();
                    google.maps.event.addDomListener(closeBtn[0], 'click', function () {
                        infowindow.close(); 
                        let prop_id =$('#iw-close-btn').attr('prop_id');
                        while ((ax = map_comps_ids.indexOf(prop_id)) !== -1) {
                            map_comps_ids.splice(ax, 1); 
                        }
                        while ((index = map_comps_unit_ids.indexOf(prop_id)) !== -1 && map_comps_unit_ids.indexOf(option_val) !== -1) {
                            map_comps_unit_ids.splice(index, 1); 
                        }
                        current_option_val[id] = 0;

                        marker.setIcon(icon);
                    });
                }
                if($('#iw-select-btn').length){
                    var selectBtn = $('#iw-select-btn').get();
                    google.maps.event.addDomListener(selectBtn[0], 'click', function () {
                        infowindow.close(); 
                        let prop_id =$('#iw-select-btn').attr('prop_id');
                        if(!map_comps_ids.includes(prop_id)){
                            map_comps_ids.push(prop_id);
                        }
                        if(!map_comps_unit_ids.includes(prop_id) && !map_comps_unit_ids.includes(option_val)){
                            map_comps_unit_ids.push({id: prop_id, unit_id: option_val});
                        }

                        option_val  = $(this).parents().find('select.comp_unit').val();
                        if(option_val != 0){
                            if(!current_option_val.hasOwnProperty(id)){
                                current_option_val = {
                                    ...current_option_val,
                                    [id]: option_val
                                };    
                            }
                            current_option_val[id] = option_val;
                            marker.setIcon(selected_icon);
                        }else{
                            marker.setIcon(icon);
                        }
                    });
                }
                CompsController.loadSideNav();
                if($('#iw-edit-btn').length){
                    var editBtn = $('#iw-edit-btn').get();
                    google.maps.event.addDomListener(editBtn[0], 'click', function () {
                        infowindow.close();
                    });
                }
                if($('#iw-view-btn').length){
                    var viewBtn = $('#iw-view-btn').get();
                    google.maps.event.addDomListener(viewBtn[0], 'click', function () {
                        infowindow.close();
                    });
                }
            });

            infowindow.open(map, marker);
        });
        markers.push(marker);
        bounds.extend(marker.position);
    }

    function clearMarkers() {
        for (var i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }
        if(markerCluster) {
            markerCluster.clearMarkers();
        }
        setDefault();
    }

    function setDefault() {
        markers = [];
        bounds = new google.maps.LatLngBounds();
        map.setCenter(Utils.getUSACenter());
        map.setZoom(14);
    }

    var fitBounds = function() {
        map.fitBounds(bounds);

        if (map.getZoom() > 20) {
            map.setZoom(20);
        }
    };

    EvaluationsCommons.init = init;
    EvaluationsCommons.initWeightSetting = initializeWeightSetting;
    EvaluationsCommons.saveEvalTotalWeight = saveEvalTotalWeight;
    EvaluationsCommons.initMap = initMap;
    EvaluationsCommons.getMap = getMap;
    EvaluationsCommons.clean = clearMarkers;
    EvaluationsCommons.resetMarkers = resetMarkers;
    EvaluationsCommons.buildListing = buildListing;
    EvaluationsCommons.checkMap = checkMap;
    EvaluationsCommons.fitBounds = fitBounds;
    EvaluationsCommons.bounds = {
        swLat: null,
        swLng: null,
        neLat: null,
        neLng: null
    };
})();
$(document).ready(function(){
    $(".most_likely_owner_user").select2({
            tags: true,
            placeholder: "Select or Type Your Own"
        }
    );
    if (location.pathname.indexOf('evaluations/areainfo') !== -1) {
        loadWikipedia();
        loadInfoArrows();
    }
    $(document).on('click', '.evaluations-next-areainfo', function () {
        $('.evaluations-next-areainfo').attr('disabled',true);
        saveAreaInfo();
    });
});

function saveAreaInfo(){
    formData = new FormData();
    formData.append('id', $('[name="evaluation[id]"]').val() );
    formData.append('city-info', $("[name='evaluation[city_info]'").val());
    formData.append('county-info', $("[name='evaluation[county_info]'").val());
    formData.append('property-summary-sales-arrow', $("[name='property-summary-sales-arrow']").val());
    formData.append('property-summary-vacancy-arrow', $("[name='property-summary-vacancy-arrow']").val());
    formData.append('property-summary-net-absorption-arrow', $("[name='property-summary-net-absorption-arrow']").val());
    formData.append('property-summary-construction-arrow', $("[name='property-summary-construction-arrow']").val());
    formData.append('property-summary-lease-rates-arrow', $("[name='property-summary-lease-rates-arrow']").val());
    
    var url = 'wggenerator/saveAreaInfo';
    if(location.pathname.indexOf('res_evaluations/') !== -1) {
        url = "wggenerator/saveResAreaInfo";
    }
    $.ajax({
        type: 'POST',
        url: $('body').attr('data-base-url') + url,
        data: formData,
        contentType: false,
        processData: false,
        beforeSend: function(){
            $('body').LoadingOverlay("show",
                {
                    image: $('body').attr('data-base-url') + "assets/img/loading.png",
                    imageAnimation: '2500ms rotate_left',
                    zIndex: 1005,
                    background: "rgba(255, 255, 255, 0.95)"
                }                  
            );                 
        },
        success: function (responseTxt) {
            $('.evaluations-next-areainfo').attr('disabled',false);
            var response = JSON.parse(responseTxt);
            if (response.status === 'success') {
                saveToast();
                var form = $('#evaluation-form');
                if(location.pathname.indexOf('res_evaluations/') !== -1) {
                    window.location.href = ResEvaluationController.createURI(form.attr('data-next'), response.id);
                }else{
                    window.location.href = EvaluationController.createURI(form.attr('data-next'), response.id);
                }
            }else if(response.status === 'fail'){  
                Materialize.toast('Something is wrong.', 2000);
                $('body').LoadingOverlay("hide");
            }  
        }
    });
}

function loadWikipedia() {
    var els = $('[data-search-string]');
    if (els.length > 0) {
        for (var i = 0; i < els.length; i++) {
            if (els.hasOwnProperty(i)) {
                var el = $(els[i]);
                var string = el.attr('data-search-string');
                var filledIn = el.attr('data-filled-in');

                if (string.length > 0 && filledIn !== 'true') {
                    $.get($('body').attr('data-base-url') + "wggenerator/get_wikipedia_info/", {string: string.split(" ").join('%20')}).then(function (el, res) {
                        return function (response) {
                            var res = JSON.parse(response);
                            var val = '';
                            if (res.status === 'success') {
                                var element = el.attr('data-text').replace('-','_');
                                if (res.data.length < 1200) {
                                    val = res.data;
                                } else {
                                    val = reduceText(res.data, 1200);
                                }
                                $('#'+element).find('.ql-editor').html("<p>" + val.replace('S..','') + "<p>");
                            }
                            var body = $('body');
                            var name = el.attr('data-text');

                            if (val.length && name.length && $('[name="evaluation[id]"]').val()) {
                                setTimeout(function() {
                                    var url = 'wggenerator/saveMeta';
                                    if(location.pathname.indexOf('res_evaluations/') !== -1) {
                                        url = "wggenerator/resSaveMeta";
                                    }
                                    $.post(body.attr('data-base-url') + url, {
                                        id: $('[name="evaluation[id]"]').val(),
                                        name: name,
                                        val: val
                                    });
                                },1000);
                            }
                        };
                    }(el));
                }
            }
        }
    }
}

function loadInfoArrows() {
    var imgContainers = $("a[data-image-arrow]");

    imgContainers.css('cursor', 'hand');

    imgContainers.click(function () {
        var name = $(this).attr('data-image-arrow');
        var direction = $(this).attr('data-name');
        $("[name='"+name+"']").val(direction);
        $("img[data-image-arrow='" + name + "']").attr('src', getArrow(direction));
    });
}

function getArrow(direction) {
    if (direction === 'up') {
        return $('body').attr('data-base-url') + 'assets/img/report/arrows/up.svg';
    } else if (direction === 'down') {
        return $('body').attr('data-base-url') + 'assets/img/report/arrows/down.svg';
    } else if (direction === 'right') {
        return $('body').attr('data-base-url') + 'assets/img/report/arrows/right.svg';
    } else if (direction === 'left') {
        return $('body').attr('data-base-url') + 'assets/img/report/arrows/left.svg';
    } else if (direction === 'up_down') {
        return $('body').attr('data-base-url') + 'assets/img/report/arrows/up_down.svg';
    } else if(direction === 'even_flat') {
        return $('body').attr('data-base-url') + 'assets/img/left-right-outer.png';
    }
}

function reduceText(text, length) {
    var pieces = text.split('.');

    var i;
    var total = pieces.length;
    var newStr = '';
    for (i = 0; i < total; i++) {
       if ((newStr.length + pieces[i].length) <= length) {
            newStr += pieces[i] + '.';
       }
    }

   newStr.replace('..', '.');

    return newStr;
}

$(document).ready(function () {
    $(document).on('change', 'select.traffic_count_adt', function(event) {
        var traffic_value = $(this).val();
        if (traffic_value == 'inputvalue')
        {
            $(this).closest('.traffic-count-row').find('.traffic_count_value').addClass('showtraffic');
            $(this).closest('.traffic-count-row').find('.traffic_count_value').removeClass('hidetraffic');
        } else {
            $(this).closest('.traffic-count-row').find('.traffic_count_value').addClass('hidetraffic');
            $(this).closest('.traffic-count-row').find('.traffic_count_value').removeClass('showtraffic');

        }
    });
    $(document).on('change', 'select.traffic_count_adt', function(event) {
        var traffic_value = $(this).val();
        if (traffic_value == 'inputvalue')
        {
            $(this).closest('.traffic-count-row').find('.traffic_count_value').addClass('showtraffic');
            $(this).closest('.traffic-count-row').find('.traffic_count_value').removeClass('hidetraffic');
        } else {
            $(this).closest('.traffic-count-row').find('.traffic_count_value').addClass('hidetraffic');
            $(this).closest('.traffic-count-row').find('.traffic_count_value').removeClass('showtraffic');

        }
    });
});

function save_review_summary(){
    var content=$(".materialize-textarea").val();
    var url = "evaluations/save";
    if(location.pathname.indexOf('res_evaluations/') !== -1) {
        url = "res_evaluations/save";
    }
    $.ajax({
        type: "POST",
        url: $("body").data("base-url") + url,
        data: {
            'evaluation[id]': $("[name='evaluation[id]']").val(),
            'evaluation[review_summary]': content
        },
        success:function(){
            saveToast();
        }
    });
}